// extracted by mini-css-extract-plugin
export default {"Root":"FileTable_Root__sWb1W","ErrorRoot":"FileTable_ErrorRoot__V9eLr","Acknowledge":"FileTable_Acknowledge__Sfq69"};